'use client';

import { createContext, useCallback, useMemo, useState } from 'react';

import { BreadcrumbsContextProps, BreadcrumbsItem } from '../config';

export const BreadcrumbsContext = createContext<BreadcrumbsContextProps>({
	list: [],
	refPage: '',
	setList: () => null,
	setRefPage: () => null,
});

export function BreadcrumbsProvider({ children }: React.PropsWithChildren) {
	// const pathname = usePathname();
	// const params = useParams();
	const [list, setStateList] = useState<BreadcrumbsItem[]>([]);
	const [refPage, setStateRefPage] = useState<string>('');
	const setList = useCallback(setStateList, [setStateList]);

	const setRefPage = useCallback(setStateRefPage, [setStateRefPage]);
	const value = useMemo(
		() => ({
			list,
			setList,
			refPage,
			setRefPage,
		}),
		[list, setList, refPage, setRefPage],
	);

	/*useEffect(() => {
		const breadcrumbs = [];

		if (pathname?.startsWith('/courses')) {
			breadcrumbs[breadcrumbs.length] = {
				title: 'Курсы',
				href: `/courses`,
			};
		}

		if (params?.courseId) {
			breadcrumbs[breadcrumbs.length] = {
				title: 'Содержание курса',
				href: `/courses/${params.courseId}`,
			};
		}

		if (params?.problemId) {
			breadcrumbs[breadcrumbs.length] = {
				title: '',
				// href: `/courses/${params.courseId}/problem/${params.problemId}`,
			};
		}

		// if (params?.theoryId) {
		// 	breadcrumbs[breadcrumbs.length] = {
		// 		title: '[theory_name]',
		// 		href: `/courses/${params.courseId}/theory/${params.theoryId}`,
		// 	};
		// }

		setList(breadcrumbs);
	}, [pathname, params, setList]);*/

	return (
		<BreadcrumbsContext.Provider value={value}>
			{children}
		</BreadcrumbsContext.Provider>
	);
}
